const radarKey =
  import.meta.env.MODE !== 'production'
    ? import.meta.env.VITE_TEST_RADAR_PUBLISHABLE_KEY
    : import.meta.env.VITE_PROD_RADAR_PUBLISHABLE_KEY;

export default radarKey;
